import styled from 'styled-components'
import { RaisedSurface } from '@ucl/react-library/raisedSurface'
import { Text } from '@ucl/react-library/text'
import { SingleSelectInput } from '@ucl/react-library/selectInput'
import { Link } from '@ucl/react-library/link'
import { ModalWindow } from '@ucl/react-library/modalWindow'
import { EditableDataList } from '@ucl/aem-library/dataList'
import { EditableButton } from '@ucl/aem-library/button'
import { EditableText } from '@ucl/aem-library/richTextEditor'

export const StyledText = styled(Text)<{
  color?: string
  paddingTop?: string
  paddingBottom?: string
  centered?: string
}>`
  padding-top: ${(props) => props.paddingTop};
  padding-bottom: ${(props) => props.paddingBottom ?? '24px'};
  color: ${(props) => props.color} !important;
  & .color-inherit {
    & .RichTextEditor {
      p {
        color: ${(props) => props.color} !important;
      }
    }
  }
`

export const Grid = styled.div<{
  numColumns?: number
  tabCols?: number
  mobileCols?: number
  padding?: string
  tabPadding?: string
  mobilePadding?: string
}>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.numColumns ?? 3}, 1fr);
  column-gap: 24px;
  row-gap: 32px;
  padding: ${(props) => props.padding};
  @media (max-width: 992px) and (min-width: 600px) {
    display: grid;
    grid-template-columns: repeat(${(props) => props.tabCols ?? 3}, 1fr);
    column-gap: 24px;
    row-gap: 32px;
    padding: ${(props) => props.tabPadding};
  }
  @media (max-width: 599px) {
    display: grid;
    grid-template-columns: repeat(${(props) => props.mobileCols ?? 3}, 1fr);
    column-gap: 24px;
    row-gap: 32px;
    padding: ${(props) => props.mobilePadding};
  }
`

export const GridItem = styled.div<{ columnSize: number; mobileColSize?: number; tabColSize?: number }>`
  grid-column: span ${(props) => props.columnSize};
  @media (max-width: 992px) and (min-width: 600px) {
    grid-column: span ${(props) => props.tabColSize ?? props.tabColSize};
  }
  @media (max-width: 599px) {
    grid-column: span ${(props) => props.mobileColSize ?? props.columnSize};
  }
`

export const DropDown = styled(SingleSelectInput)`
  padding-bottom: 24px;
`

export const MarginWrapper = styled.div<{ margin?: string; marginTop?: string }>`
  margin: ${(props) => props.margin};
  margin-top: ${(props) => props.marginTop};
`
export const FlexContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`

export const StyledTextNoPadding = styled(Text)<{ color?: string; paddingBottom?: string; mobilePadding?: string }>`
  color: ${(props) => props.color} !important;
  padding-bottom: ${(props) => props.paddingBottom};
  p {
    color: ${(props) => props.color} !important;
  }
  ${(props) =>
    props.mobilePadding &&
    `@media (max-width: 599px) {
    padding: ${props.mobilePadding} !important;
  }
  `};
`

export const StyledEditableInLineAlert = styled.div`
  .RichTextEditor {
    p {
      color: inherit !important;
    }
  }
`

// TODO - tech debt: use aem
export const StyledTermsAndConditionTextWarpper = styled(EditableText)`
  & .small-text {
    color: #4d5b6d;
  }
  & p {
    padding-bottom: 24px;
  }
`

export const FlexGap = styled.div<{ gap: string; direction?: string; mobileDirection?: string }>`
  display: flex;
  flex-direction: ${(props) => props.direction ?? 'column'};
  gap: ${(props) => props.gap};
  ${(props) =>
    props.mobileDirection &&
    `@media (max-width: 599px) {
    flex-direction: ${props.mobileDirection};
  }
  `};
`

export const ModalWindowWrapper = styled(ModalWindow)<{ mobileHeight?: string }>`
  &.ModalWindow__container {
    max-height: fit-content !important;
    height: auto !important;
  }
  ${(props) =>
    props.mobileHeight &&
    `@media (max-width: 599px) {
      max-height: ${props.mobileHeight} !important`};
`

export const FooterWrapper = styled.div<{ mobileWidth?: string; mobileFlexDirection?: string }>`
  margin-top: 24px;
  display: flex;
  gap: 24px;
  ${(props) =>
    props.mobileWidth &&
    `@media (max-width: 599px) {
      width: ${props.mobileWidth} !important`};
  ${(props) =>
    props.mobileFlexDirection &&
    `@media (max-width: 599px) {
        flex-direction: ${props.mobileFlexDirection} !important`};
`

export const EditableButtonWrapper = styled(EditableButton)<{
  isEntrollButton?: boolean
  isEditButton?: boolean
  isHavingSvgImage?: boolean
  mobileWidth?: string
}>`
  ${(props) =>
    props.isEditButton &&
    `@media (max-width: 599px) {
      font-size: 14px !important;
    }`}
  ${(props) =>
    props.isHavingSvgImage &&
    `@media (max-width: 599px) {
        svg {
          width: 24px !important;
        }
      }`}
      ${(props) =>
    props.mobileWidth &&
    `@media (max-width: 599px) {
        width: ${props.mobileWidth} !important;
      }`}
`

export const ErrorSpan = styled.span`
  color: #d62d0a;
`

export const ErrorText = styled(Text.P)`
  color: #d62d0a;
`

export const StyledErrorMessage = styled.div`
  color: #d62d0a;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`

export const GrayContainer = styled.div`
  background-color: #fafafb;
  padding: 24px;
  border-radius: 8px;
  @media (max-width: 599px) {
    padding: 16px;
  }
`

export const StyledH4 = styled(Text.H4)<{ color?: string; paddingBottom?: string; fontSize?: string }>`
  padding-bottom: ${(props) => props.paddingBottom ?? '24px'};
  color: ${(props) => props.color} !important;
  ${(props) => props.fontSize && `font-size: ${props.fontSize} !important`};
`
export const StyledH5 = styled(Text.H5)<{ color?: string; paddingBottom?: string; fontSize?: string }>`
  padding-bottom: ${(props) => props.paddingBottom ?? '24px'};
  color: ${(props) => props.color} !important;
  ${(props) => props.fontSize && `font-size: ${props.fontSize} !important`};
`

export const StyledRaisedSurface = styled(RaisedSurface)`
  margin: 24px 0;
  ${RaisedSurface.Container} {
    padding: 24px;
    @media (max-width: 599px) {
      padding: 16px;
    }
  }
`

export const Bold = styled.b<{ fontWeight?: number }>`
  font-weight: ${(props) => props.fontWeight ?? '500'} !important;
`

export const StyledWrapper = styled(Text)<{ padding?: string; mobilePadding?: string; color?: string }>`
  padding: ${(props) => props.padding};
  ${(props) =>
    props.mobilePadding &&
    `@media (max-width: 599px) {
    padding: ${props.mobilePadding} !important;
  }
  `};
`

export const RadioButtonConatiner = styled.label<{
  padding?: string
  border?: string
  borderRadius?: string
  background?: string
}>`
  display: flex;
  padding: ${(props) => props.padding ?? '24px 16px'};
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  cursor: pointer;
  flex: 1 0 0;
  width: 100%;
  border-radius: ${(props) => props.borderRadius ?? '8px'};
  border: ${(props) => props.border ?? '1px solid #9CA3AD'};
  background: ${(props) => props.background ?? '#FFF'};
  /* Style the selected option differently */
  &.selected {
    background-color: #e6f1fd; /* Light blue background for selected option*/
    border: 1px solid #066fef !important;
  }
  & .RadioButton__label {
    display: inline-block;
    margin-bottom: 4px;
    font-weight: 600;
  }
`
export const StyledLink = styled(Link)<{ underline?: boolean; fontSize?: string }>`
  font-size: ${(props) => props.fontSize} !important;
  text-decoration: ${(props) => (props.underline ? 'underline !important' : 'none')};
`

export const StyledTextPaddingWrapper = styled(Text)<{ padding?: string; mobilePadding?: string }>`
  padding: ${(props) => props.padding};
  ${(props) =>
    props.mobilePadding &&
    `@media (max-width: 599px) {
    padding: ${props.mobilePadding} !important;
  }
  `};
`

type DataListProps = {
  flexDirection?: 'column-reverse' | 'column'
  titlePadding?: string
  ListContentFlexDirection?: string
  ListContentGap?: string
}

export const StyledDatalist = styled(EditableDataList)<DataListProps>`
  .Rule--action {
    margin: 0px;
  }

  .datalist-item {
    background: inherit !important;
    flex-direction: ${({ flexDirection = 'column' }) => flexDirection};

    .title {
      word-break: break-word;
      padding: ${({ titlePadding = '0px' }) => titlePadding};
    }

    .enroll-button {
      width: max-content !important;
    }

    .opt-out-button {
      white-space: nowrap;
    }

    .ListContent {
      flex-direction: ${({ ListContentFlexDirection = 'row' }) => ListContentFlexDirection};
      gap: ${({ ListContentGap = '4px 16px' }) => ListContentGap};
      @media (max-width: 599px) {
        flex-direction: column;
      }
    }
  }
`

export const SpinnerWrapper = styled(MarginWrapper)`
  div {
    display: grid !important;
  }
`

export const CheckBoxInfoToolTipWrapper = styled.div`
  label {
    cursor: pointer !important;
  }
  label .Label__text {
    flex: 0 !important;
  }
`
export const StyledMobileSvgImage = styled.div`
  @media (max-width: 599px) {
    .edit-button {
      font-size: 14px !important;
    }
    .enroll-button {
      padding: 4px 16px;
    }
    svg {
      width: 24px !important;
    }
  }
`
